// Libraries
import React from "react";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from "../../../../routes/routes";
import phrasebookLoad from "../../../../i18n";
import * as token from '../../../../helpers/token';
import { accountTypesConstants } from '../../../../constants';
import { initialState, companyForm, submitValues } from '../companyForm';

// Redux
import { customerActions, georesourceActions, accountActions } from 'actions';

// Components
import { NewBreadcrumbs } from "../../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SubmitButton, CancelButton } from "../../../../components/SkyFramework/Buttons";
import { Form } from "../../../../components/SkyFramework/Forms";

const phrasebook = phrasebookLoad()

class CustomerAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = initialState(undefined, this.props.match.params.id);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];

  }

  componentDidMount() {
    this.props.dispatch(georesourceActions.getCountries(null, 1000));
    this.props.dispatch(georesourceActions.getCountryCodes(null, 1000));
    if (this.props.match.params.id)
      this.props.dispatch(accountActions.getAccount(this.props.match.params.id));
  }

  componentDidUpdate(prevProps) {

    if (this.props.dialcodes && prevProps && prevProps.dialcodes !== this.props.dialcodes) {
      this.setState({ dialcodes: this.props.dialcodes.data });
    };
    if (this.props.cities && prevProps && prevProps.cities !== this.props.cities) {
      this.setState({ cities: this.props.cities.data });
    }
    if (this.props.account && prevProps && prevProps.account !== this.props.account) {
      this.setState({
        master_email: this.props.account.email,
        master_account: this.props.account
      });
    }
  }

  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) {
      this.setState({ [id]: value });
      if (value) {
        if (id === 'address_country') {
          var code = this.state.dialcodes.find(element => element.name === value);
          this.props.dispatch(georesourceActions.getCities(undefined, code.code, 10000));
        }
      } else {
        if (id === 'address_country') {
          this.setState({ address_country: undefined });
          this.setState({ cities: [] });
        }
      }
    }
    else if (name) {
      this.setState({ [name]: value });
    }
  }


  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    var newValues = submitValues(this.state);
    newValues.master_email = undefined;
    this.props.dispatch(customerActions.add(newValues, this.state.master_id))
  }
  FormProfile = () => {
    if (this.state.dialcodes && this.state.cities && this.state.master_account) {
      const countries = this.state.dialcodes.map(dialcode => {
        return { value: dialcode.name, label: `${dialcode.name} (${dialcode.dial_code})` }
      });
      const cities = this.state.cities.map(city => {
        return { value: city.name, label: `${city.name}` }
      });
      const inputs = companyForm(phrasebook, this.state, { countries: countries, cities: cities })
      const buttons = [<CancelButton title={phrasebook.common.back} link={gisRoutes.account.customer.list} />, <SubmitButton title={phrasebook.common.add} />]
      return (
        <Form
          handleSubmit={this.handleSubmit}
          onChange={this.handleChange}
          title={`${phrasebook.common.add} ${phrasebook.common.customer}`}
          inputs={inputs}
          buttons={buttons}
        />)
    } else return null;
  }

  render() {
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.account.customer.list, label: phrasebook.headerlinks.customers }]} current={`${phrasebook.common.add} ${phrasebook.common.customer}`} />

      {this.FormProfile()}
    </>
  }
}

function mapStateToProps(state) {
  const { georesource, authentication, account } = state;
  const { authUser } = authentication;
  return {
    authUser,
    dialcodes: georesource.dialcodes,
    cities: georesource.cities,
    account: account.account
  };
}


const customerAdd = connect(mapStateToProps)(CustomerAdd);
export default (customerAdd);
